import ControlerIconHover from './component'

export default ControlerIconHover
